module.exports = __webpack_public_path__ + "img/footer2.85930fe4.svg";